<style src="./SpotList.scss" lang="scss"></style>
<template>
  <div>
    <div class="mail-box-header">
      exhibition
      <form class="form-spot">
        <div class="col-lg-8">
          <select class="form-control" v-model="form.selectedPark">
            <option
              v-for="(park, index) in parksList"
              :key="index"
              :value="park"
            >
              {{ park.parkName }}
            </option>
          </select>
        </div>
        <div class="input-group-btn col-lg-4">
          <button
            type="button"
            class="btn btn-md btn-primary"
            @click="toggleShowAllSpots()"
          >
            {{ !showAllSpots ? 'Mostar Todas' : 'Mostar por Estacionamento' }}
          </button>
        </div>
      </form>
    </div>
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome</th>
            <th v-if="showAllSpots">Estacionamento</th>
            <th>tolerancia</th>
            <th>
              relacionado<br />
              com agenda
            </th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(spot, key) in formattedSpots" :key="key">
            <td>{{ spot.name }}</td>
            <td v-if="showAllSpots">{{ spot.parkName }}</td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Tolerancia"
                  v-model="spot.continuousTolerance"
                />
              </div>
            </td>
            <td @click.prevent="relateSpot(spot._id, spot.continuousTolerance)">
              <switches
                v-model="spot.related"
                theme="bootstrap"
                color="success"
                :emit-on-mount="false"
              ></switches>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Switches from 'vue-switches';
export default {
  components: { Switches },
  props: {
    selectedSchedule: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      form: {
        selectedPark: {},
      },
      showAllSpots: false,
      selectedSpot: '',
      continuousTolerance: '',
      parksList: [],
    };
  },
  computed: {
    formattedSpots() {
      if (this.showAllSpots) {
        let allSpots = [];
        this.parksList.forEach(park => {
          const formatted = park.spots
            .filter(
              spot =>
                String(spot.tariffSchedule) === String(this.selectedSchedule),
            )
            .map(spot => ({ ...spot, related: true, parkName: park.parkName }));
          allSpots = allSpots.concat(formatted);
        });

        return allSpots;
      } else {
        if (!this.form.selectedPark.spots) {
          return [];
        }
        return this.form.selectedPark.spots.map(spots => ({
          ...spots,
          related:
            String(spots.tariffSchedule) === String(this.selectedSchedule),
        }));
      }
    },
  },

  mounted() {
    this.ListParks();
  },
  methods: {
    async ListParks(parkIndex) {
      try {
        const parksList = await this.$store.dispatch('PARKING/GetParkList');
        this.parksList = parksList;
        this.form.selectedPark = parkIndex
          ? parksList[parkIndex]
          : parksList[0];
      } catch (error) {
        this.$toasted.error('Não foi possível listar estacionarmentos');
      }
    },
    toggleShowAllSpots() {
      this.showAllSpots = !this.showAllSpots;
    },

    async relateSpot(spotId, continuousTolerance) {
      try {
        if (!this.selectedSchedule) {
          return;
        }
        await this.$store.dispatch('RELATE/RelateSpot', {
          tariffScheduleId: this.selectedSchedule,
          spotId,
          continuousTolerance: continuousTolerance
            ? Number(continuousTolerance)
            : null,
        });
        const parkIndex = this.parksList.findIndex(
          park => String(park._id) === String(this.form.selectedPark._id),
        );
        await this.ListParks(parkIndex);
        this.$toasted.success('Vaga relacionada com sucesso!');
      } catch (error) {
        this.$toasted.error('Não foi possível relacionar a vaga');
      }
    },
  },
};
</script>